import './ScreenSingle.scss';
import { Screen } from '@components/Component/Container/Screen/Screen.js';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { combineLatest, filter, map } from 'rxjs';
/**
 * The `ScreenSingle` class extends the `Screen` class.
 * Represents a screen that fills the viewport.
 */
export class ScreenSingle extends Screen {
    constructor(id, rootElement, dependencies = {}, screenGroupId = '') {
        super(id, rootElement, dependencies, screenGroupId);
        this.componentName = 'ScreenSingle';
        this.updateHistory = true;
        // TODO: not sure if/where we should display title for single page mode. maybe overwrite the titleSet functionality to write the title to browser tab
        this.screenTitleContainer = document.createElement('span');
    }
    /**
     * Setup to sync the browser address bar with this screen in single screen mode.
     */
    draw() {
        super.draw();
        if (this.updateHistory) {
            this.propertyGet$('currentForm')
                .pipe(filter((form) => !!form), switchMap((form) => {
                // if (form) {
                return combineLatest([
                    form.propertyGet$('formName'),
                    form.propertyGet$('parameters'),
                    form.getHashFromCurrentTab$()
                ]);
                // } else {
                // 	return of(['', {}]); 
                // }
            }), filter(([formName]) => formName !== 'error'), map(() => {
                // Get the current URL up to the pathname, excluding search and hash.
                return this.currentForm.getCurrentUrl();
            }), distinctUntilChanged(), debounceTime(300))
                .subscribe((url) => {
                if (window.location.href !== url) {
                    // Update the address bar
                    history.pushState({}, '', url);
                }
            });
        }
        this.propertyGet$('currentForm')
            .pipe(filter((form) => !!form), switchMap((form) => {
            return form.propertyGet$('title');
        })).subscribe((title) => {
            document.title = title;
        });
    }
    /**
     * Provides the HTML structure for the `ScreenSingle`.
     * @returns The HTML structure for the screen.
     */
    template() {
        const template = `
			<div class="screen-content"></div>
		`;
        return template;
    }
}
ScreenSingle.VERSION = '$Revision: 112122 $';
